import * as React from "react";
import { Contract, Feature } from "@/utils/contract";
import logger from "@/mixins/redux-hooks-logger";

type FetchAction = {
  type: "CONTRACT_FETCH";
  result: Partial<Contract>;
};

type Action = FetchAction;

const reducer = (state: Partial<Contract> = {}, action: Action): Partial<Contract> => {
  switch (action.type) {
    case "CONTRACT_FETCH": {
      const result = {
        ...action.result,
      };
      result.featuresObj = {};
      if (result.features && result.features.length) {
        const features = result.features.map(feature => JSON.parse(feature));
        features.forEach(feature => {
          switch (feature.name) {
            case Feature.COLOR_THEME:
              result.featuresObj![feature.name] = { color: feature.extras };
              break;
              
            case Feature.TITLE:
              result.featuresObj![feature.name] = { title: feature.extras };
              break;

            case Feature.ESTIMATION_RESULT_CONTACT:
              result.featuresObj![feature.name] = { contact: feature.extras };
              break;

            default:
              result.featuresObj![feature.name] = feature.extras;
          }
        });
      }
      return result;
    }
    default:
      return state;
  }
};

export interface IContractContext {
  state: Contract;
  dispatch: (action: Action) => void;
}

export const fetchActionCreator = (result: Contract): FetchAction => ({
  type: "CONTRACT_FETCH",
  result,
});

export const initContractStore: (initialState: Contract) => IContractContext = initialState => {
  const [state, dispatch] = React.useReducer(
    process.env.NODE_ENV === "development" ? logger(reducer) : reducer,
    initialState
  );
  return {
    state,
    dispatch: action => {
      dispatch(action);
    },
  };
};

export default React.createContext<IContractContext | null>(null);
